import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=a5503258&scoped=true"
import script from "./Brands.vue?vue&type=script&lang=ts"
export * from "./Brands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5503258",
  null
  
)

export default component.exports